import { GET_CONTRACTS, GET_CONTRACT } from '../actions/types';

import { INITIAL_STATE } from '../states/states';

export default (state = INITIAL_STATE.CONTRACTS, action) => {
  switch (action.type) {
    case GET_CONTRACTS:
      return { ...state, contracts: action.payload };
    case GET_CONTRACT:
      return { ...state, contractInfo: action.payload };
    default:
      return state;
  }
};
